import styled from '@emotion/styled';

export const ExpertAdviceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    padding: 60px 0;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP_LG} {
    padding: 80px 0;
  }
`;

export const ExpertAdviceTiles = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    margin: 40px -24px;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
`;

export const ExpertAdviceTileContainer = styled.div`
  width: 294px;
  padding: 20px 0px;

  box-sizing: content-box;

  &:last-child {
    border-right: none;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    padding: 0px 24px;
    border-bottom: none;
    border-right: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP_XL} {
    padding: 0px 40px;
    width: 374px;
  }
`;

export const ExpertAdviceTileTitle = styled.h4`
  margin-top: 24px;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.4px;
  font-weight: ${props => props.theme.FONTS.FONT_WEIGHT_REGULAR};

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_LARGE};
    line-height: 32px;
  }
`;

export const ExpertAdviceTileImage = styled.picture`
  border-radius: 16px;
  overflow: hidden;
  display: block;

  img {
    display: block;
    width: 100%;
  }
`;
